import React, { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";

const SCROLL_THRESHOLD_PX = 30;

const NAV_ITEMS = [
  { id: "work", label: "Work" },
  { id: "awards", label: "Awards" },
  { id: "cases", label: "Case Decks" },
  { id: "story", label: "Story" },
  { id: "artifacts", label: "Artifacts" }
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > SCROLL_THRESHOLD_PX);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
    // Empty deps intentional: subscription set up once on mount; setScrolled is stable.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed top-4 left-1/2 -translate-x-1/2 z-50 transition-all duration-300 ${
        scrolled ? "w-[min(96%,980px)]" : "w-[min(96%,1100px)]"
      }`}
    >
      <nav className="flex items-center justify-between px-4 sm:px-6 py-3 rounded-full bg-[#FFF8E7]/85 backdrop-blur-md border-[1.5px] border-[#0F0F10] shadow-[4px_4px_0_#0F0F10]">
        <button onClick={() => scrollTo("hero")} className="flex items-center gap-2 group">
          <span className="w-9 h-9 rounded-full bg-[#0F0F10] text-[#FFE357] grid place-items-center font-bold text-sm">
            TS
          </span>
          <span className="font-semibold tracking-tight hidden sm:inline">Tharun Sai</span>
        </button>

        <ul className="hidden md:flex items-center gap-1">
          {NAV_ITEMS.map((it) => (
            <li key={it.id}>
              <button
                onClick={() => scrollTo(it.id)}
                className="px-4 py-2 rounded-full text-sm font-medium hover:bg-[#FFE357] transition-colors"
              >
                {it.label}
              </button>
            </li>
          ))}
        </ul>

        <button
          onClick={() => scrollTo("contact")}
          className="flex items-center gap-2 px-4 py-2 rounded-full bg-[#0F0F10] text-[#FFE357] text-sm font-semibold hover:bg-[#1f1f20] transition-colors"
        >
          <Sparkles className="w-4 h-4" />
          <span>Let's talk</span>
        </button>
      </nav>
    </header>
  );
}
